<template>
	<div class="field has-addons" :class="{ 'only-two': options.length <= 2 }">
		<b-radio-button
			v-for="{ value, label } in options"
			:key="value"
			v-model="selected"
			:native-value="value"
			:class="`gtm-option${name ? `-${name}` : ``}-${value}`"
			expanded
			:data-test="`button__${name ? `${name}` : ``}-${value}`"
		>
			<span>{{ label }}</span>
		</b-radio-button>
	</div>
</template>

<script>
export default {
	name: "FieldOptionButtons",
	props: {
		options: {
			type: Array,
			required: true
		},
		preSelect: {
			type: [String, Boolean],
			default: () => null
		},
		name: {
			type: String,
			default: () => null
		}
	},
	data() {
		return {
			selected: ""
		};
	},
	watch: {
		selected(data) {
			this.$emit("change", data);
		},
		preSelect(value) {
			this.selected = value;
		}
	},
	created() {
		if (this.preSelect || typeof this.preSelect === "boolean") {
			this.selected = this.preSelect;
		}
	}
};
</script>

<style scoped>
.field.only-two >>> .control {
	width: 50%;
}
</style>
